import React from "react";
import type {VoidFunctionComponent} from "react";
import s from "./PointsAwarded.module.scss";

export interface IPointsAwardedProps {
  points: number;
}

export const PointsAwarded: VoidFunctionComponent<IPointsAwardedProps> = ({points}) => {
  return <div className={s.pointsAwarded}>
    <dt>Points awarded</dt>
    <dd>{points}</dd>
  </div>;
}

